// The viewer's time zone, for the footer note: "America/Toronto (EDT)". Every timestamp in
// the app is the API's UTC value shown in this zone. Falls back to just the offset where the
// browser cannot name the zone.
export default function localTimeZoneLabel(now: Date = new Date()): string {
  let zone = '';
  let abbreviation = '';
  try {
    zone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZoneName: 'short',
    }).formatToParts(now);
    abbreviation = parts.find((p) => p.type === 'timeZoneName')?.value || '';
  } catch {
    // Older engines: fall through to the offset below.
  }
  if (!abbreviation) {
    const offset = -now.getTimezoneOffset();
    const sign = offset >= 0 ? '+' : '-';
    const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, '0');
    const minutes = String(Math.abs(offset) % 60).padStart(2, '0');
    abbreviation = `UTC${sign}${hours}:${minutes}`;
  }
  return zone ? `${zone.replace(/_/g, ' ')} (${abbreviation})` : abbreviation;
}
